/**
 * @generated SignedSource<<c7c29779535861ae0f0d3660c7de06fe>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  /** AppStorageEntityValue */
  AppStorageEntityValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredCustomEntityFieldValue: {
    input: any;
    output: any;
  };
  /** AppStoredEntityFieldValue */
  AppStoredEntityFieldValue: {
    input: any;
    output: any;
  };
  /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
  BigDecimal: {
    input: any;
    output: any;
  };
  /** Supported colors in the Palette */
  CardPaletteColor: {
    input: any;
    output: any;
  };
  /** CardTypeHierarchyLevelType */
  CardTypeHierarchyLevelType: {
    input: any;
    output: any;
  };
  /** A date scalar that accepts string values that are in yyyy-mm-dd format */
  Date: {
    input: any;
    output: any;
  };
  /** A scalar representing a specific point in time. */
  DateTime: {
    input: Date;
    output: Date;
  };
  /**
   * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
   * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
   * Please talk to #uip-app-framework before using this.
   * The definition of the scalar is yet to be decided based on spike insights.
   * To learn about current state see https://go.atlassian.com/JSDependency
   * DO NOT USE: Platform teams are iterating on the final shape of data returned
   */
  JSDependency: {
    input: any;
    output: any;
  };
  /**
   * The `JSON` scalar type represents JSON values as specified
   * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
   *
   * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
   * from a consumers point of view.  There are legitimate use cases for this scalar type
   * but it SHOULD not be a common scalar.
   */
  JSON: {
    input: {
      [key: string]: any;
    };
    output: {
      [key: string]: any;
    };
  };
  /**
   * Atlassian Document Format (ADF) - A JSON format for rich text content.
   * @see https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/
   *
   * TODO: Implement custom scalar with ADF validation
   */
  KitsuneADF: {
    input: any;
    output: any;
  };
  /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
  Long: {
    input: number;
    output: number;
  };
  /** MercuryJSONString */
  MercuryJSONString: {
    input: any;
    output: any;
  };
  /** SoftwareBoardFeatureKey */
  SoftwareBoardFeatureKey: {
    input: any;
    output: any;
  };
  /** SoftwareBoardPermission */
  SoftwareBoardPermission: {
    input: any;
    output: any;
  };
  /** SprintScopeChangeEventType */
  SprintScopeChangeEventType: {
    input: any;
    output: any;
  };
  /** Position for a card - can be a numeric position or relative position ('top' or 'bottom') */
  TrelloCardPosition: {
    input: any;
    output: any;
  };
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: {
    input: any;
    output: any;
  };
  /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
  URL: {
    input: any;
    output: any;
  };
  /** UUID */
  UUID: {
    input: any;
    output: any;
  };
  /** Upload */
  Upload: {
    input: any;
    output: any;
  };
  /**
   * View Template Resource Identifier.
   *
   * Format: 'vtri:<resource>:<kind>:<value>'.
   *
   * For fields:
   * - 'vtri:field:ref:<ref>' is a template-scoped identifier a template defines to uniquely
   *   reference a field in the template definition. It is not an existing field.
   *   It must be resolved to a concrete field when instantiating the view.
   * - 'vtri:field:id:<id>' refers to an existing concrete field in the DB (e.g. 'vtri:field:id:customfield_10055').
   */
  VTRI: {
    input: any;
    output: any;
  };
}
export enum ConfluenceGroupUsageType {
  ADMIN_OVERSIGHT = "ADMIN_OVERSIGHT",
  TEAM_COLLABORATION = "TEAM_COLLABORATION",
  USERBASE_GROUP = "USERBASE_GROUP",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content =
  {
    __typename?: "Content";
    id: string | null;
    hasViewRestrictions: boolean;
    links: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    base: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    links: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions =
  {
    __typename?: "UserWithRestrictions";
    type: string | null;
    displayName: string | null;
    email: string | null;
    accountId: string | null;
    hasSpaceViewPermission: boolean | null;
    hasSpaceEditPermission: boolean | null;
    permissionType: SitePermissionType | null;
    profilePicture: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon | null;
    restrictingContent: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean;
    endCursor: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions =
  {
    __typename?: "PaginatedUserWithRestrictions";
    count: number | null;
    nodes: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions | null> | null;
    pageInfo: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
    usageType: ConfluenceGroupUsageType | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean;
    endCursor: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList =
  {
    __typename?: "PaginatedGroupList";
    count: number | null;
    nodes: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group | null> | null;
    pageInfo: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType =
  {
    __typename?: "SubjectsByType";
    userWithRestrictions: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions | null;
    group: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction =
  {
    __typename?: "ContentRestriction";
    restrictions: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    base: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    links: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions =
  {
    __typename?: "UserWithRestrictions";
    type: string | null;
    displayName: string | null;
    email: string | null;
    accountId: string | null;
    hasSpaceViewPermission: boolean | null;
    hasSpaceEditPermission: boolean | null;
    permissionType: SitePermissionType | null;
    profilePicture: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon | null;
    restrictingContent: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean;
    endCursor: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions =
  {
    __typename?: "PaginatedUserWithRestrictions";
    count: number | null;
    nodes: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions | null> | null;
    pageInfo: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
    usageType: ConfluenceGroupUsageType | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean;
    endCursor: string | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList =
  {
    __typename?: "PaginatedGroupList";
    count: number | null;
    nodes: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group | null> | null;
    pageInfo: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType =
  {
    __typename?: "SubjectsByType";
    userWithRestrictions: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions | null;
    group: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction =
  {
    __typename?: "ContentRestriction";
    restrictions: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions =
  {
    __typename?: "ContentRestrictions";
    read: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction | null;
    update: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content =
  {
    __typename?: "Content";
    id: string | null;
    hasInheritedRestrictions: boolean;
    ancestors: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content | null> | null;
    operations: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult | null> | null;
    restrictions: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions | null;
  };
export type useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild =
  {
    __typename?: "PaginatedContentListWithChild";
    nodes: Array<useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild_nodes_Content | null> | null;
  };
export type useQueriesShareAndRestrictDialogQuery_user_AtlassianUser_emails_AtlassianUserEmail =
  {
    __typename?: "AtlassianUserEmail";
    value: string | null;
    isPrimary: boolean | null;
  };
export type useQueriesShareAndRestrictDialogQuery_user_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    value: string | null;
    isPrimary: boolean | null;
  };
export type useQueriesShareAndRestrictDialogQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  displayName: string | null;
  emails: Array<useQueriesShareAndRestrictDialogQuery_user_AtlassianUser_emails_AtlassianUserEmail | null> | null;
  photos: Array<useQueriesShareAndRestrictDialogQuery_user_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
};
export type useQueriesShareAndRestrictDialogQuery_space_Space_currentUser_SpaceUserMetadata =
  {
    __typename?: "SpaceUserMetadata";
    isAdmin: boolean;
  };
export type useQueriesShareAndRestrictDialogQuery_space_Space = {
  __typename?: "Space";
  id: string | null;
  currentUser: useQueriesShareAndRestrictDialogQuery_space_Space_currentUser_SpaceUserMetadata;
};
export type useQueriesShareAndRestrictDialogQuery_license_License = {
  __typename?: "License";
  trialEndDate: string | null;
};
export type useQueriesShareAndRestrictDialogQuery_Query = {
  __typename?: "Query";
  content: useQueriesShareAndRestrictDialogQuery_content_PaginatedContentListWithChild | null;
  user: useQueriesShareAndRestrictDialogQuery_user_AtlassianUser | null;
  space: useQueriesShareAndRestrictDialogQuery_space_Space | null;
  license: useQueriesShareAndRestrictDialogQuery_license_License | null;
};
export type useQueriesShareAndRestrictDialogQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  status?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  draftShareId?: InputMaybe<Scalars["String"]["input"]>;
  spaceKey: Scalars["String"]["input"];
}>;
export type useQueriesShareAndRestrictDialogQuery =
  useQueriesShareAndRestrictDialogQuery_Query;
